export type PendingImagesSource = () => Iterable<HTMLImageElement>;

type Registration = { source: PendingImagesSource };

const registrations: Registration[] = [];

/**
 * Tells the export where to find images a renderer has requested but cannot draw
 * yet. Canvas renderers resolve component images through a cache that is only
 * populated on load, and skip drawing until then — so an image in flight leaves
 * no trace in the pass that asked for it, and the export would otherwise settle
 * without it (ARD-33431).
 *
 * Every registration is consulted, so a second image cache adds to the answer
 * rather than replacing it. Returns the handle that removes this one again, and
 * only this one however often it is called.
 */
export const registerPendingImagesSource = (
  source: PendingImagesSource
): VoidFunction => {
  const registration = { source };
  registrations.push(registration);
  return () => {
    const index = registrations.indexOf(registration);
    if (index !== -1) registrations.splice(index, 1);
  };
};

export const getPendingImages = (): HTMLImageElement[] =>
  registrations.flatMap(({ source }) => [...source()]);
